import React, { useState, useEffect } from "react";
import SimpleReactValidator from "simple-react-validator";
import emailjs from "@emailjs/browser";

const Contactpage = () => {
  const [forms, setForms] = useState({
    name: "",
    email: "",
    adress: "",
    service: "",
    note: "",
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  // ✅ FORCE RERENDER FOR SimpleReactValidator
  const [, forceUpdate] = useState();

  // ✅ KEEP VALIDATOR INSTANCE STABLE
  const [validator] = useState(
    () =>
      new SimpleReactValidator({
        autoForceUpdate: { forceUpdate },
      })
  );

  /* ✅ AUTO REFRESH AFTER SUCCESS */
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        window.location.reload();
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [success]);

  const changeHandler = (e) => {
    setForms({ ...forms, [e.target.name]: e.target.value });
    validator.showMessages();
    forceUpdate({});
  };

  const submitHandler = (e) => {
    e.preventDefault();

    // ✅ VALIDATION (NOW WORKING)
    if (!validator.allValid()) {
      validator.showMessages();
      forceUpdate({});
      return;
    }

    setLoading(true);
    setSuccess("");
    setError("");

    emailjs
      .send(
        "service_pttfqb9",
        "template_m61pci7",
        {
          name: forms.name,
          email: forms.email,
          adress: forms.adress,
          service: forms.service,
          message: forms.note,
          year: new Date().getFullYear(),
        },
        "25jJDEk32eKXromlv"
      )
      .then(() => {
        setSuccess("Thank you! Your message has been sent successfully.");

        setForms({
          name: "",
          email: "",
          adress: "",
          service: "",
          note: "",
        });

        validator.hideMessages();
        setLoading(false);
      })
      .catch(() => {
        setError("Failed to send message. Please try again later.");
        setLoading(false);
      });
  };

  /* ================= STYLES ================= */
  const styles = {
    section: { paddingBottom: 60, width: "100%" },
    container: { maxWidth: 1200, margin: "0 auto", padding: "0 16px" },

    officeGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(3, 1fr)",
      gap: 24,
      marginBottom: 40,
    },

    officeCard: {
      background: "#fff",
      borderRadius: 12,
      boxShadow: "0 10px 30px rgba(0,0,0,0.06)",
      padding: 30,
      minHeight: 220,
      textAlign: "center",
    },

    iconCircle: {
      width: 72,
      height: 72,
      borderRadius: "50%",
      background: "#F4F6F8",
      margin: "0 auto 14px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },

    icon: { fontSize: 28 },

    cardTitle: {
      fontSize: 26,
      fontWeight: 700,
      marginBottom: 8,
      color: "#0A1B4D",
    },

    cardText: {
      fontSize: 15,
      color: "#6B7280",
      whiteSpace: "pre-line",
    },

    titleWrap: { textAlign: "center", marginBottom: 25 },

    title: { fontSize: 32, fontWeight: 800, color: "#0A1B4D" },

    subtitle: {
      maxWidth: 650,
      margin: "0 auto",
      color: "#6B7280",
      fontSize: 15,
    },

    formWrap: {
      background: "#fff",
      borderRadius: 14,
      boxShadow: "0 10px 30px rgba(0,0,0,0.06)",
      padding: 28,
    },

    formGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(2, 1fr)",
      gap: 18,
    },

    input: {
      width: "100%",
      height: 52,
      borderRadius: 10,
      border: "1px solid #E5E7EB",
      padding: "0 14px",
      outline: "none",
    },

    select: {
      width: "100%",
      height: 52,
      borderRadius: 10,
      border: "1px solid #E5E7EB",
      padding: "0 14px",
      background: "#fff",
    },

    textarea: {
      width: "100%",
      minHeight: 140,
      borderRadius: 10,
      border: "1px solid #E5E7EB",
      padding: 14,
    },

    full: { gridColumn: "1 / -1" },

    submitWrap: {
      gridColumn: "1 / -1",
      textAlign: "center",
      marginTop: 10,
    },

    button: {
      backgroundColor: "#FACD2B",
      border: "1px solid #FACD2B",
      padding: "14px 28px",
      borderRadius: 10,
      fontWeight: 700,
      cursor: "pointer",
    },

    success: { marginTop: 12, color: "green" },
    error: { marginTop: 12, color: "red" },
  };

  return (
    <section style={styles.section}>
      <div style={styles.container}>
        {/* CONTACT CARDS */}
        <div style={styles.officeGrid}>
          <div style={styles.officeCard}>
            <div style={styles.iconCircle}>
              <i className="fi flaticon-placeholder" style={styles.icon}></i>
            </div>
            <h2 style={styles.cardTitle}>Address</h2>
            <p style={styles.cardText}>
              {"Unit 1\n40 B Wallace Avenue\nPoint Cook VIC 3030"}
            </p>
          </div>

          <div style={styles.officeCard}>
            <div style={styles.iconCircle}>
              <i className="fi flaticon-email" style={styles.icon}></i>
            </div>
            <h2 style={styles.cardTitle}>Email Us</h2>
            <p style={styles.cardText}>qualityhomesinvic@gmail.com</p>
          </div>

          <div style={styles.officeCard}>
            <div style={styles.iconCircle}>
              <i className="fi flaticon-phone-call" style={styles.icon}></i>
            </div>
            <h2 style={styles.cardTitle}>Call Now</h2>
            <p style={styles.cardText}>02 8798 5845</p>
          </div>
        </div>

        {/* FORM */}
        <div style={styles.formWrap}>
          <form onSubmit={submitHandler}>
            <div style={styles.formGrid}>
              <div>
                <input
                  style={styles.input}
                  name="name"
                  value={forms.name}
                  onChange={changeHandler}
                  placeholder="Your Name*"
                />
                {validator.message("name", forms.name, "required|alpha_space")}
              </div>

              <div>
                <input
                  style={styles.input}
                  name="email"
                  value={forms.email}
                  onChange={changeHandler}
                  placeholder="Your Email*"
                />
                {validator.message("email", forms.email, "required|email")}
              </div>

              <div>
                <input
                  style={styles.input}
                  name="adress"
                  value={forms.adress}
                  onChange={changeHandler}
                  placeholder="Address"
                />
                {validator.message("adress", forms.adress, "required")}
              </div>

              <div>
                <select
                  style={styles.select}
                  name="service"
                  value={forms.service}
                  onChange={changeHandler}
                >
                  <option value="" disabled>
                    Select a Service
                  </option>
                  <option value="Home Build">Home Build</option>
                  <option value="Site Prep">Site Prep</option>
                  <option value="Plan Design">Plan Design</option>
                  <option value="Build Service">Build Service</option>
                </select>
                {validator.message("service", forms.service, "required")}
              </div>

              <div style={styles.full}>
                <textarea
                  style={styles.textarea}
                  name="note"
                  value={forms.note}
                  onChange={changeHandler}
                  placeholder="Message..."
                />
                {validator.message("note", forms.note, "required|min:10")}
              </div>

              <div style={styles.submitWrap}>
                <button type="submit" style={styles.button} disabled={loading}>
                  {loading ? "Sending..." : "Get in Touch"}
                </button>

                {success && <div style={styles.success}>{success}</div>}
                {error && <div style={styles.error}>{error}</div>}
              </div>
            </div>
          </form>
        </div>
      </div>

      {/* MOBILE GRID FIX */}
      <style>
        {`
          @media (max-width: 768px) {
            div[style*="grid-template-columns: repeat(3, 1fr)"] {
              grid-template-columns: 1fr !important;
            }
            div[style*="grid-template-columns: repeat(2, 1fr)"] {
              grid-template-columns: 1fr !important;
            }
          }
        `}
      </style>
    </section>
  );
};

export default Contactpage;
